<aside id="sidebar_left">
        <div class="sidebar-left-content nano-content">
            <!--<a href="/" class="logo-middle">
                <img src="<% envassets('img/logo.png') %>" alt="Teleskop Logo" class="mw40">
            </a>
            -->
            <ul class="nav sidebar-menu">
    
                
                <li class="nav navbar-nav navbar-left dropdown pull-right hidden-xs" id="eCompanyDropDown">
                    <a href="#" class="dropdown-toggle">
                        <img ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ authenticatedUser.logo }}" alt="avatar" class="mw30">
                        <span class="hidden-xs hidden-sm"><name>{{ ::authenticatedUser.full_name }}</name> </span>
                        <span class="fa fa-caret-down hidden-xs mr15"></span>
                    </a>
                    
                    <ul class="nav sub-nav" role="menu"> 
                        <li>
                            <a class="fs14" href="#" ng-click="logout()"> 
                            <i class="fa fa-power-off"></i> Güvenli Çıkış </a>
                        </li>
                    </ul>
                </li>
                <li class="dropdown hidden-xs" >
                    <a class="fs14" href="/customer-tracking" >
                        <span class="fa fa-map"></span> Kargo Takip 
                    </a>
                </li>
                <li class="dropdown hidden-xs" >
                    <a class="fs14" href="/customer-orders" >
                        <span class="fa fa-list"></span> Kargo Listesi
                    </a>
                </li>
                <li class="dropdown hidden-xs" >
                    <a class="fs14" href="/customer-new-order">
                        <span class="fa fa-plus"></span> Kargo Emri Oluştur
                    </a>
                </li>
                <li class="dropdown hidden-xs">
                    <a class="fs14" href="/customer-account" >
                        <span class="fa fa-user-o"></span> Hesap Bilgileri
                    </a>
                </li>
    
            </ul>
        </div>
    </aside>